export interface Notification {
  key?: string;
  text: string;
  ctaLabel?: string;
  link?: string;
  dismissable?: boolean;
  timeout?: number;
  severity?: string;
}
